export default "__VITE_ASSET__DQAk0LiZ__"